module.exports = __webpack_public_path__ + "static/img/GL-6-A智能安全帽使用说明书-3.156e0d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/GL-6-A智能安全帽使用说明书-3.jpg
// module id = 5r3/
// module chunks = 0